import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className='footer'>
        Copyright &#169; 2025 beepali srikanth. ALl rights Received.

    </footer>
  )
}

export default Footer
